/** Design choices a new player makes when founding a house (all optional on the wire). */
import type { Sex } from './types';
import type { CrestSpec } from './heraldry';

/** Names: 1-24 letters, spaces, hyphens, apostrophes. */
export const NAME_RE = /^[\p{L}\p{M}][\p{L}\p{M}'’ \-]{0,23}$/u;
export const MAX_NAME_LEN = 24;

export interface FoundHead { name: string; sex: Sex; faceSeed: number }
export interface FoundSpouse { name: string; faceSeed: number }
export interface FoundChild { name: string; sex: Sex; faceSeed: number }
export interface FoundFamily {
  head: FoundHead;
  /** Always the opposite sex of the head. */
  spouse: FoundSpouse;
  /** Exactly START_STATE.childCount, eldest first. */
  children: FoundChild[];
}

export interface HouseDesign {
  crest?: CrestSpec;
  family?: FoundFamily;
}
